import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { UserService } from "@main-services/user.service";

@Component({
	selector: "trade-staking-dialog",
	template: "",
	standalone: false
})
export class TradeStakingDialogComponent implements OnInit {
	constructor(
		private router: Router,
		private route: ActivatedRoute,
		private userService: UserService
	) {}

	public ngOnInit(): void {
		if (this.userService.isUnverified) {
			return;
		}

		// Takes the "home" screen as background in case it's called from the outside via /trade/stake
		const route: string = this.route.snapshot.parent.routeConfig.path;
		const routeTarget: string = route === "trade" ? "home" : route;
		this.router.navigate([routeTarget, { outlets: { modal: "stake" } }], {
			skipLocationChange: true
		});
	}
}
